<template>

    <p class="
    text-muted text-center" >
      <i class="feather icon-search display-4 d-block m-3"></i>
       - Nessuna risorsa trovata -
    </p>

</template>
<script>
export default {
  name: "noresult"}
  </script>